import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mat-midi-creator',
  templateUrl: './midi-creator.component.html',
  styleUrls: ['./midi-creator.component.scss'],
})
export class MidiCreatorComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
